<ion-card class="card-custom" *ngIf="corePrinciples.length > 0 || leadershipPrinciples.length > 0">
    <ion-grid>
        <ion-row>
            <ion-col *ngIf="corePrinciples.length > 0">
                <ion-card-header>
                    <ion-card-title>
                        {{ 'dashboard.corePrinciples' | translate }}
                    </ion-card-title>
                </ion-card-header>
                <mat-accordion [multi]="true" class="custom-accordion">
                    <mat-expansion-panel *ngFor="let corePrinciple of corePrinciples">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ corePrinciple.title | translate }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        {{ corePrinciple.description | translate }}
                    </mat-expansion-panel>
                </mat-accordion>
            </ion-col>
            <ion-col *ngIf="leadershipPrinciples.length > 0">
                <ion-card-header>
                    <ion-card-title>
                        {{ 'dashboard.leadershipPrinciples' | translate }}
                    </ion-card-title>
                </ion-card-header>
                <mat-accordion [multi]="true" class="custom-accordion">
                    <mat-expansion-panel *ngFor="let leadershipPrinciple of leadershipPrinciples">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{ leadershipPrinciple.title | translate }}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        {{ leadershipPrinciple.description | translate }}
                    </mat-expansion-panel>
                </mat-accordion>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-card>